module.exports = __webpack_public_path__ + "static/media/faqImage2.543e2b9b.svg";